<template>
    <div class="sortingDebug">
        <debugArticleDisplay
                :article="article"
                :index="index"
                :key="article.id"
                v-for="(article, index) in getAllArticles"></debugArticleDisplay>
    </div>
</template>
<script>
    import store from '@/store';

    export default {
        name: 'debugArticleSort',
        components: {
            'debugArticleDisplay': () => import('@/components/debugArticleDisplay')
        },
        props: ['article'],
        computed: {
            getAllArticles: () => {
                return store.state.articlesFullList;
            }
        }
    };
</script>
<style lang="scss">
    @import "../scss/DebugVariables";

    .sortingDebug {
        display: flex;
        flex-flow: row wrap;
        width: 100%;

        .Dev {
            flex: 1;

            &-container {
                position: relative;
            }
        }
    }

    /*
    .Dev-switch {
        margin:10px;
        padding:5px 10px;
        position:fixed;
        top:0;
        right:0;
        z-index:3;
        color:$c1;
        cursor:pointer;
    }
    body.showDebug .Dev-switch {
        @media all and (min-width: $xs) { //480
            color: $c2;
        }
        @media all and (min-width: $s) { //736
            color: $c3;
        }
        @media all and (min-width: $m) { //980
            color: $c4;
        }
        @media all and (min-width: $l) { //1280
            color: $c5;
        }
        @media all and (min-width: $xl) { //1690
            color: $c6;
        }
    }
    */
</style>
